import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';

type PostUploadCrlvParams = {
  deliverymanId: string;
  file: FormData;
};

const postUploadCrlv = async ({ deliverymanId, file }: PostUploadCrlvParams) =>
  apiClient
    .post(
      `entregadores/${deliverymanId}/send-deliveryman-crlv-picture-by-manager`,
      file,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    .then(response => {
      handleResponseSuccess(response, 'O CRLV foi enviado com sucesso!')();
    })
    .catch(
      handleResponseThrowError('Não foi possível enviar o CRLV do entregador.'),
    );

export const usePostUploadCrlv = ({
  onSuccess,
}: { onSuccess?: () => void } = {}) => {
  return useMutation({
    mutationFn: postUploadCrlv,
    onSuccess,
  });
};
